import api from "./api";

export const listChatWidgets = () => api.get("/chat-widget");

export const createChatWidget = (data) => api.post("/chat-widget", data);

export const updateChatWidget = (id, data) => api.put(`/chat-widget/${id}`, data);

export const deleteChatWidget = (id) => api.delete(`/chat-widget/${id}`);
